import parse from "html-react-parser";
import { t } from "i18next";
import React from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

import Button from "@atoms/Button";
import Dim from "@atoms/Dim";
import Icon from "@atoms/Icon";
import Image from "@atoms/Image";
import Link from "@atoms/Link";

import { useLayoutStore } from "@store/layout";

export default function Popup() {
  const { isPC } = useCheckDevice();
  const { popup, openPopup } = useLayoutStore();

  const handleClose = () => {
    openPopup(null);
  };

  const handleHideToday = () => {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    localStorage.setItem("popup", JSON.stringify(midnight.getTime()));
    openPopup(null);
  };

  return (
    <div className="relative">
      <section className="center pc:w-1/3 fixed z-80 flex max-h-[calc(100%-2rem)] w-[calc(100%-2rem)] flex-col rounded-sm bg-white shadow lg:w-1/4">
        <div className="absolute top-5 right-5 z-10">
          <Button as="wrapper" onClick={handleClose}>
            {isPC ? "Close" : <Icon name="Close" />}
          </Button>
        </div>
        {popup?.image ? <Image height={popup.image.height || 500} src={popup.image.url} width={popup.image.width || 400} /> : null}

        <div className="flex flex-col gap-5 p-4">
          <h2 className="text-title">{popup?.title || ""}</h2>
          <div className="flex flex-col gap-5">
            {parse(popup?.description || "")}

            <div className="pc:gap-1 flex gap-2.5">
              {popup?.buttonText && popup?.url ? (
                <Link as="square" className="flex! w-full items-center justify-center" href={popup.url}>
                  {popup.buttonText}
                </Link>
              ) : null}

              <Button as="square" className="w-full" onClick={handleHideToday} variant="secondary">
                {t("popup_close")}
              </Button>
            </div>
          </div>
        </div>
      </section>
      <Dim onClick={handleClose} />
    </div>
  );
}
